import classNames from 'classnames';
import { memo, forwardRef, ButtonHTMLAttributes } from 'react';

export interface FilterButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick' | 'color'> {
  isSelected: boolean;
  onClick: () => void;
  children: React.ReactNode;
  hasBorder?: boolean;
  className?: string;
  showColorIndicator?: boolean;
  color?: string | null;
}

const DEFAULT_INDICATOR_COLOR = '#6b7280';

export const FilterButton = memo(
  forwardRef<HTMLButtonElement, FilterButtonProps>(
    (
      { isSelected, onClick, children, hasBorder = false, className, showColorIndicator = false, color, ...props },
      ref,
    ) => {
      const indicatorColor = color || DEFAULT_INDICATOR_COLOR;

      return (
        <button
          ref={ref}
          onClick={onClick}
          className={classNames(
            'flex items-center gap-2 rounded-[8px] px-4 py-2 font-haffer text-sh-14-20 transition-colors',
            {
              'border border-black': hasBorder && isSelected,
              'border border-dashed border-gray-400': hasBorder && !isSelected,
              'text-gray-700 hover:bg-gray-200': !isSelected,
            },
            className,
          )}
          {...props}>
          {children}
          {showColorIndicator && (
            <span
              className={classNames('h-[14px] w-[14px] shrink-0 rounded-full', {
                'border border-gray-400': !isSelected,
              })}
              style={isSelected ? { backgroundColor: indicatorColor } : undefined}
              aria-hidden
            />
          )}
        </button>
      );
    },
  ),
);

FilterButton.displayName = 'FilterButton';
